var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkingIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "193px",
    height: "168px",
    viewBox: "0 0 193 168",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "undraw_check_boxes_m3d0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-8-Copy-26",
    transform: "translate(-87.000000, -228.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_check_boxes_m3d0",
    transform: "translate(87.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 87,
    cy: 165.5,
    rx: 53,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 26.5,
    cy: 26.5,
    r: 26.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FEC532",
    cx: 26,
    cy: 26,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 96.5,
    cy: 26.5,
    r: 26.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 97,
    cy: 26,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 166.5,
    cy: 26.5,
    r: 26.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 167,
    cy: 26,
    r: 22
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "24.2707609 35 18 26.7866923 21.646588 23.8970469 24.6157508 27.7861446 34.6460911 17 38 20.2370957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3495986,31.9950577 C71.6198867,27.837977 71.339064,23.9144952 73.7774457,20.429426 L73.7774457,20.429426 L73.7774457,20.429426 C73.8649676,18.0634907 74.9121059,15.8337912 76.6798809,14.2491933 C78.4476559,12.6645955 80.785213,11.8603223 83.1590708,12.0199265 L84.7489193,12.12682 C88.0979371,12.3432566 91.0283576,14.4445154 92.2943935,17.5373041 C95.2590175,24.8536806 95.3523344,34.5775343 94.6124593,45 L72.8685185,45 C74.1599654,40.1257747 74.8229771,35.5511362 73.3495986,31.9950577 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3881663,45.0686245 L39.6024086,42.4605164 C38.4359521,41.9347001 37.5544405,40.9265946 37.1864896,39.6976474 C36.8185388,38.4687001 37.0003984,37.1399842 37.6849041,36.0560959 L37.6849041,36.0560959 C38.4438583,34.8543228 39.7324181,34.092128 41.1477435,34.0077952 C42.563069,33.9234624 43.9324564,34.5272821 44.8277968,35.6304832 L47.5007527,38.9239869 L59.9622132,50.0147333 L68.2457447,44.4674939 L72,50.8548798 L58.5629289,59 L45.3881663,45.0686245 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5734118,52 L66,43.0827615 L83.8083066,35 L83.9624927,36.7057032 C84.2511895,39.8994067 82.8583048,43.0100239 80.3017892,44.8808575 L70.5734118,52 Z",
    id: "Path",
    fill: "#18683E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,35.3203873 L76.032609,50 L75,48.5728152 L79.9565205,39.8058253 L82.2282602,38.7864076 C82.7725491,36.5098463 81.383038,33.4569079 79.5434769,30.2233013 L88.2173897,29 C88.6360562,31.7772897 90.5426005,33.8933968 94,35.3203873 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F2E41",
    points: "116 138.536432 112.988557 143 89 129.401266 92.3230728 113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7886599,160 L78.9130191,157.813953 L77.6681693,100.560355 L73,69.4352168 L91.1539761,66 L94.8885095,74.1196034 C104.065967,86.7504659 90.6872877,125.452073 83.7886599,160 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7228566,158.550624 L85.7332239,160.803724 C86.1181785,161.662166 86.0849719,162.656432 85.6436445,163.485904 C85.202317,164.315376 84.404679,164.882677 83.4918988,165.01628 L70.133807,166.971494 C68.7756664,167.170284 67.482793,166.311281 67.1058948,164.959706 L67.1058948,164.959706 C66.7606955,163.721809 67.2798396,162.401794 68.3662767,161.754965 L79.5884148,156 L84.7228566,158.550624 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.266195,137.186127 L117.760282,137.007899 C118.710541,136.939993 119.637951,137.312851 120.262108,138.013737 C120.886265,138.714623 121.133895,139.661256 120.930125,140.567419 L117.948056,153.828666 C117.644863,155.17696 116.365829,156.100356 114.952556,155.991263 L114.952556,155.991263 C113.658147,155.891344 112.598643,154.948601 112.380283,153.702463 L111,141.148953 L115.266195,137.186127 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB8B8",
    cx: 82.5,
    cy: 24.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8755547,67.2372873 L73.0424905,71 L72.6325348,58.8757063 C70.0502696,56.0876672 76.0728193,44.9214626 78.1669331,39.644069 L80.8316446,38.8079107 L76.3221354,47.1694917 L92.1054216,34 L95.1800888,34.8361584 L96,50.096046 L90.8755547,67.2372873 Z",
    id: "Path",
    fill: "#18683E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.60156,74.3601208 L88.7342799,79.3280709 C87.954604,80.3296472 86.7852383,80.938064 85.5294512,80.995532 C84.273664,81.053 83.0551722,80.5538576 82.1899846,79.6275545 L82.1899846,79.6275545 C81.230699,78.6005008 80.8161938,77.1675328 81.076055,75.7766364 C81.3359162,74.38574 82.2384344,73.2066378 83.5014573,72.6079501 L87.2720975,70.8206244 L100.800776,61.4513437 L97.5211044,52.082063 L104.49044,50 L109,64.9908481 L92.60156,74.3601208 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4682036,43 L78.1120678,43 C78.6890657,40.1826605 80.2359067,37.6267284 84.4663312,35.7941299 C87.5510073,30.0717209 88.8688542,24.881276 84.4663312,21.4131624 C79.4375533,20.2886901 77.48995,18.2467729 78.1120678,15.4397166 L87.1139292,14 C94.5169716,20.3994553 94.6014884,31.3232996 93.4682036,43 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,50.7282606 L96.3548314,53 L93,34 L94.668099,34.2567185 C97.791375,34.7373917 100.422557,36.8114042 101.583235,39.7075298 L106,50.7282606 Z",
    id: "Path",
    fill: "#18683E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingIllustration);
export default __webpack_public_path__ + "static/media/working_illustration.8138956f60576a8240cf3a7b47c620d1.svg";
export { ForwardRef as ReactComponent };